import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { HomePage } from './pages/HomePage';
import { DocumentPage } from './pages/DocumentPage';
import { FormDetailPage } from './pages/FormDetailPage';
import { ChecklistPage } from './pages/ChecklistPage';
import { SchemesPage } from './pages/SchemesPage';
import { SchemeDetailPage } from './pages/SchemeDetailPage';
import { AboutPage } from './pages/AboutPage';
import { ContactPage } from './pages/ContactPage';
import { PrivacyPolicyPage } from './pages/PrivacyPolicyPage';
import { TermsOfServicePage } from './pages/TermsOfServicePage';
export const AppRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path='/' element={<HomePage />} />
      <Route path='/document' element={<HomePage />} />
      <Route path='/document/:categoryId' element={<DocumentPage />} />
      <Route path='/document/:categoryId/:formId' element={<FormDetailPage />} />
      <Route path='/document/:categoryId/:formId/checklist' element={<ChecklistPage />} />
      <Route path='/checklist' element={<ChecklistPage />} />
      <Route path='/schemes' element={<SchemesPage />} />
      <Route path='/scheme/:schemeId' element={<SchemeDetailPage />} />
      <Route path='/about' element={<AboutPage />} />
      <Route path='/contact' element={<ContactPage />} />
      <Route path='/feedback' element={<ContactPage />} />
      <Route path='/privacy_policy' element={<PrivacyPolicyPage />} />
      <Route path='/terms_of_service' element={<TermsOfServicePage />} />
    </Routes>
  );
};
